// extracted by mini-css-extract-plugin
module.exports = {"containerMoreInfo":"styles_containerMoreInfo__120fd"};